export default "__VITE_ASSET__BzrpFP1W__"